import { render, staticRenderFns } from "./bind-phone.vue?vue&type=template&id=99d5f5fc&scoped=true&"
import script from "./bind-phone.vue?vue&type=script&lang=js&"
export * from "./bind-phone.vue?vue&type=script&lang=js&"
import style0 from "./bind-phone.vue?vue&type=style&index=0&id=99d5f5fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d5f5fc",
  null
  
)

export default component.exports